import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import nl2br from 'react-nl2br';

import _ from 'lodash';

import './carriers.less';
import {connect} from "react-redux";
import moment from "moment";
import formats from "dictionaries/formats";
import {Link} from "react-router";
import GlobalLoaderComponent from "components/ui/global-loader";
import Select from 'components/ui/select';
import {getCarriers} from "store/reducers/organizational_units/carriers";
import TextField from "components/ui/text-field";
import Input from "../../ui/form/input";

@connect((state) => ({}), {getCarriers})

export default class CarriersComponent extends Component {

    state = {
        items: [],
        loading: false,
        selectedCarrier: null,
        selectedRoute: null,
        routeSearch: '',
    };

    async componentDidMount() {
        this.setState({loading: true});
        const response = await this.props.getCarriers({
            filters: {
                withComponent: 'kiutr',
                withActive: true,
                withStatus: true,
                active_routes: true
            },
        });
        this.setState({loading: false});
        if (response.isOk) {
            this.setState({
                items: _.sortBy(_.filter(response.payload.items, (unit) => {
                    return unit.routes.length > 0;
                }), 'name')
            });
        } else {
            response.showErrors();
        }
    }

    routeChange({target: {value}}) {
        this.setState({
            routeSearch: value,
        });
        return false;
    }

    keyPress(e) {
        console.log('value', e.target.value);
        if (e.keyCode == 13) {
            console.log('value', e.target.value);
            // put the login here
            return false;
        }

    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;

        return (
            <Page pageId="Carriers" title="Перевозчики">
                {loader}
                <div className="page-block">
                    <div className="b-block _md">
                        <div className="f-search f-search_gray f-search_left">
                            <form action="">
                                <Select
                                    placeholder="Перевозчик"
                                    value={this.state.selectedCarrier}
                                    options={_.map(this.state.items, (item) => ({value: item.uuid, label: item.name}))}
                                    onChange={::this.carrierSelect}
                                />
                            </form>
                        </div>
                    </div>
                    <div className="b-block _md">
                        <div className="f-search f-search_gray f-search_left">
                            <form>
                                <Input value={this.state.routeSearch} onChange={::this.routeChange} onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        ev.preventDefault();
                                    }
                                }}
                                       placeholder="Маршрут"/>
                            </form>
                        </div>
                    </div>
                    <div className="carrier-title">Основные подразделения</div>
                    <div>
                        {this.state.items.map(::this.renderItem)}
                    </div>
                </div>
            </Page>
        );
    }

    carrierSelect(e) {
        const carrier = e ? e.value : null;

        this.setState({
            selectedCarrier: carrier,
            selectedRoute: null,
        });
    }

    routeSelect(e) {
        const route = e ? e.value : null;

        this.setState({
            selectedRoute: route,
            selectedCarrier: null,
        });
    }

    renderItem(carrier) {
        if (this.state.selectedCarrier && this.state.selectedCarrier !== carrier.uuid) {
            return null;
        }
        if (this.state.routeSearch && (_.filter(carrier.routes || [], (route) => {
            return route.number.toLowerCase().indexOf(this.state.routeSearch.toLowerCase()) !== -1;
        }).length === 0)) {
            return null;
        }

        return (
            <div key={carrier.uuid} className="carrier-item">
                <div className="carrier-item__caption">{carrier.name}</div>
                <div className="carrier-item__num">{carrier.routes.map(route => route.number).join(', ')}</div>
                <div className="carrier-item__info">
                    <div>
                        <span className="bold">Адрес:</span>
                        <span>{_.get(carrier, 'legal_address')}</span>
                    </div>
                    <div>
                        <span className="bold">Телефон:</span>
                        <span>{_.get(carrier, 'phone')}</span>
                    </div>
                    <div>
                        <span className="bold">Email:</span>
                        <span><a href={`mailto:${_.get(carrier, 'email')}`}>{_.get(carrier, 'email')}</a></span>
                    </div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/modules/carriers/carriers.js